import type { Mat3 } from '../core/math';

export const QUAD_ATTRIB_LOCATION = 0;

/**
 * Maps the unit quad straight onto the render target's clip space *without* a Y
 * flip, so quad `y = 0` lands on texture row 0. Combined with the row-0-is-top
 * convention in `texture.ts`, every offscreen pass keeps document orientation.
 */
export const QUAD_TO_TARGET: Mat3 = new Float32Array([2, 0, 0, 0, 2, 0, -1, -1, 1]);

export class QuadGeometry {
  private readonly gl: WebGL2RenderingContext;
  private readonly vao: WebGLVertexArrayObject;
  private readonly buffer: WebGLBuffer;

  constructor(gl: WebGL2RenderingContext) {
    this.gl = gl;
    this.vao = gl.createVertexArray()!;
    this.buffer = gl.createBuffer()!;

    gl.bindVertexArray(this.vao);
    gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
    gl.bufferData(
      gl.ARRAY_BUFFER,
      new Float32Array([0, 0, 1, 0, 0, 1, 1, 1]),
      gl.STATIC_DRAW,
    );
    gl.enableVertexAttribArray(QUAD_ATTRIB_LOCATION);
    gl.vertexAttribPointer(QUAD_ATTRIB_LOCATION, 2, gl.FLOAT, false, 0, 0);
    gl.bindVertexArray(null);
  }

  draw(): void {
    const { gl } = this;
    gl.bindVertexArray(this.vao);
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
  }

  dispose(): void {
    this.gl.deleteVertexArray(this.vao);
    this.gl.deleteBuffer(this.buffer);
  }
}
